/**
 * Bausteine, die das volle Menü (AppLayout) und die schmale Leiste (CompactNavRail) teilen —
 * damit beide dieselben Ziele, Farben und Zahlen zeigen.
 */
import { Badge } from '@mantine/core';
import { IconClipboardText, IconFileInvoice, IconTruck } from '@tabler/icons-react';
import type { NavBadge } from '../../hooks/useNavBadges';

/** Die drei Schnellaktionen oben im Menü. */
export const NAV_QUICK_ACTIONS = [
  { label: 'Service', tooltip: 'Service Report starten', path: '/service-report', icon: IconClipboardText, color: 'orange' },
  { label: 'Delivery', tooltip: 'Delivery Report starten', path: '/delivery-report', icon: IconTruck, color: 'cyan' },
  { label: 'Angebot', tooltip: 'Angebotsanforderung (Kunden-Hub)', path: '/customer-hub', icon: IconFileInvoice, color: 'blue' },
] as const;

/** Zahl am Menüpunkt: die letzte des Badges (= Gesamt), 0 ohne Badge. */
export function navBadgeCount(badge: NavBadge | undefined): number {
  return badge ? badge.parts[badge.parts.length - 1] : 0;
}

export const NAV_COUNT_MAX = 99;

/** Roter Zähler rechts am Menüpunkt; ab 100 „99+". */
export function NavCountBadge({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <Badge size="xs" variant="filled" color="red" circle={count < 10}>
      {count > NAV_COUNT_MAX ? `${NAV_COUNT_MAX}+` : count}
    </Badge>
  );
}
